import { render } from "./HomeScreens.vue?vue&type=template&id=608dfe9c&ts=true"
import script from "./HomeScreens.vue?vue&type=script&lang=ts"
export * from "./HomeScreens.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__